var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefreshCcw = function SvgRefreshCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "refresh-ccw_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4v6h6M23 20v-6h-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9.001 9.001 0 0 1 3.51 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgRefreshCcw as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMSA0VjEwSDciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0yMyAyMFYxNEgxNyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTIwLjQ5IDguOTk5OTVDMTkuOTgyOCA3LjU2Njc0IDE5LjEyMDkgNi4yODUzNiAxNy45ODQ1IDUuMjc1MzdDMTYuODQ4MiA0LjI2NTM5IDE1LjQ3NDUgMy41NTk3MiAxMy45OTE3IDMuMjI0MjFDMTIuNTA4OSAyLjg4ODcgMTAuOTY1MiAyLjkzNDI5IDkuNTA0ODEgMy4zNTY3M0M4LjA0NDM3IDMuNzc5MTYgNi43MTQ3NSA0LjU2NDY3IDUuNjQgNS42Mzk5NUwxIDkuOTk5OTVNMjMgMTRMMTguMzYgMTguMzZDMTcuMjg1MyAxOS40MzUyIDE1Ljk1NTYgMjAuMjIwNyAxNC40OTUyIDIwLjY0MzJDMTMuMDM0OCAyMS4wNjU2IDExLjQ5MTEgMjEuMTExMiAxMC4wMDgzIDIwLjc3NTdDOC41MjU0NyAyMC40NDAyIDcuMTUxOCAxOS43MzQ1IDYuMDE1NDcgMTguNzI0NUM0Ljg3OTEzIDE3LjcxNDUgNC4wMTcxNyAxNi40MzMyIDMuNTEgMTUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";